<template>
  <div class="mafco-certifications">
    <Ban :urls="[banner]" :tabs="tabs"/>
    <ul>
      <li v-for="(item, index) in imgs" :key="index">
        <div>
          <img :src="item.path" alt="mafco" :style="{width:item.width}"/>
          <div class="cn" v-if="language=='1'">{{item.title}}</div>
          <div class="cn" v-else>{{item.titleEN}}</div>
        </div>
      </li>
      <li style="border:none;"></li>
      <li style="border:none;"></li>
      <li>
        <img :src="lastZizhi" alt="mafco">
      </li>
    </ul>
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer.vue'
import Ban from '@/components/sub-page-banner.vue'
export default {
  components: {
    Footer, Ban
  },
  data () {
    return {
      lastZizhi: require('@/assets/img/zizhi/last-zizhi.png'),
      imgs: [{
        path: require('@/assets/img/zizhi/FSSC22000.jpg'),
        title: 'FSSC22000食品安全体系认证',
        titleEN: 'FSSC22000 Certificate'
      }, {
        path: require('@/assets/img/zizhi/ISO9001.jpg'),
        title: 'ISO9001质量管理体系认证',
        titleEN: 'ISO9001 Certificate',
        width: 260
      }, {
        path: require('@/assets/img/zizhi/ISO22000.jpg'),
        title: 'ISO22000食品安全管理体系认证',
        titleEN: 'ISO22000 Certificate',
        width: 260
      }, {
        path: require('../../assets/img/zizhi/REACH.png'),
        title: 'REACH认证',
        titleEN: 'REACH Certificate'
      }, {
        path: require('../../assets/img/zizhi/Halal.png'),
        title: 'Halal清真洁食认证',
        titleEN: 'Halal Certificate'
      }, {
        path: require('../../assets/img/zizhi/Kosher.png'),
        title: 'Kosher犹太洁食认证',
        titleEN: 'Kosher Certificate'
      }, {
        path: require('../../assets/img/zizhi/FDA.png'),
        title: '美国食品和药物管理局认证',
        titleEN: 'FDA Registered'
      }, {
        path: require('../../assets/img/zizhi/SEDEX.png'),
        title: 'SEDEX认证',
        titleEN: 'Sedex Qualified'
      }],
      tabs: [{
        title: '专利资质',
        titleEN: 'Quality Certifications',
        isActive: true
      }],
      banner: require('../../assets/img/sub-banner/zizhi1.jpg')
    }
  },
  computed: {
    language () {
      return this.$store.state.language || '1'
    }
  }
}
</script>

<style scoped lang="scss">
.mafco-certifications {
  margin-top: 88px;
  ul {
    width: 1280px;
    margin: 50px auto 150px;
    overflow: hidden;
    li {
      width: 25%;
      padding: 20px 0 5px;
      float: left;
      list-style-type: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: solid 3px rgba(0,104,25);
      margin-left: 6%;
      &:last-of-type {
        border-bottom: none;
        & > div:hover {
          box-shadow: none;
          transform: none;
        }
      }

      & > div {
        width: 96%;
        padding-top: 50px;
        height: 300px;
        margin: 0 auto;
        background-color: rgba($color: #fff, $alpha: .8);
        // background-color: #fff;
        border-radius: 5px;

        &:hover {
          box-shadow: 1px 1px 10px #999;
          transform: scaleX(1.02) scaleY(1.01);
        }
      }
      &:not(:first-of-type) img,
      &:not(:last-of-type) img {
        width: 180px;
      }
      &:first-of-type, &:nth-of-type(2), &:nth-of-type(3) {
        img {
          width: 260px;
          margin: 30px 0 27px;
        }
      }
      &:last-of-type {
        img {
          width: 400px;
          margin-left: -40px;
        }
      }

      .cn {
        margin: 20px 0 10px;
        font-size: 22px;
        font-family: Arial, Helvetica, sans-serif;
      }
      .cn1 {
        line-height: 220px;
        font-size: 26px;
        font-weight: bold;
      }
      .img1 {
        width: 260px !important;
        padding-top: 60px;
      }
      .en {
        font-size: 20px;
      }
    }
  }
  .mafco-footer {
    clear: both;
  }
}
</style>
